module.exports = __webpack_public_path__ + "img/mintong.90898b6e.png";